import { render, staticRenderFns } from "./ReservationTotals.vue?vue&type=template&id=71c86301"
import script from "./ReservationTotals.vue?vue&type=script&lang=js"
export * from "./ReservationTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports